<template>
  <section class="vcenter">
    <form class="vcenter-form" @submit.prevent="submit">
      <h1>{{$t('welcome.title')}}</h1>
      <b-message v-if="done" type="is-success" has-icon>
        <p>{{$t('welcome.message1')}}</p>
        <p>{{$t('welcome.message2')}}</p>
      </b-message>

      <template v-else>

        <b-message v-if="errorMessage" type="is-danger">{{ errorMessage }}</b-message>

        <b-field :label="$t('welcome.field-title')">
          <b-input v-model="email" type="email" />
        </b-field>

        <div class="form-buttons">
          <button class="button is-primary" type="submit">{{$t('welcome.btn-valider')}}</button>
          <div class="right">
            <router-link class="small" to="/">{{$t('welcome.btn-retour')}}</router-link>
          </div>
        </div>

      </template>

      <b-loading :active="loading" :is-full-page="false" />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      errorMessage: null,
      done: false,
      loading: false,
    }
  },
  created () {
    if (process.env.NODE_ENV === 'dev') {
      this.email = 'simon@tarchichi.com'
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  },
  methods: {
    async submit () {
      this.errorMessage = null
      if (!this.email) {
        this.errorMessage = this.$t('welcome.error1')
        return
      }
      this.loading = true
      try {
        await this.$api.post('/login/init', {
          email: this.email,
        })
        this.done = true
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          this.errorMessage = e.message || this.$t('welcome.error2')
        }
      }
      this.loading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.message-body {
  p+p {
    margin-top: 1em;
  }
}
</style>
